<template>
    <div class="card shadow-sm" @click="$emit('click')">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <h5 class="card-title">{{ ticket.event_pos_item.name }}</h5>
            <p class="card-text text-muted">{{ ticket.event_pos_item.description }}</p>
          </div>
          <div class="col-md-4 text-right">
            <h5 class="mb-1">${{ ticket.amount }}</h5>
            <small class="text-muted">{{ new Date(ticket.created_at).toLocaleDateString() }}</small>
          </div>
        </div>
        <div class="mt-3 d-flex justify-content-between align-items-center">
          <span 
            class="badge"
            :class="{
              'badge-success': ticket.transaction_type === 'CREDIT_PENDING',
              'badge-danger': ticket.transaction_type === 'DEBIT'
            }"
          >
            {{ ticket.transaction_type }}
          </span>
          <button class="btn btn-link">View Details →</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TicketCard',
    props: {
      ticket: {
        type: Object,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .card {
    cursor: pointer;
    transition: box-shadow 0.2s;
    background: #FFFFFF;
    border: 1px solid #E6E9ED;
    border-radius: 8px;
  }
  
  .card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,.08)!important;
  }

  .card-body {
    padding: 1.5rem;
  }

  .card-title {
    color: #1434CB;
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .card-text {
    color: #6C7074;
    font-size: 0.875rem;
  }

  .text-muted {
    color: #6C7074 !important;
  }

  .mb-1 {
    color: #1434CB;
    font-size: 1.25rem;
    font-weight: 600;
  }

  .badge {
    font-size: 0.75rem;
    font-weight: 500;
    padding: 0.375rem 0.75rem;
    border-radius: 1rem;
    text-transform: uppercase;
  }

  .badge-success {
    background-color: #E5F6ED;
    color: #1A7F37;
  }

  .badge-danger {
    background-color: #FFEBE6;
    color: #CF3123;
  }

  .btn-link {
    color: #1434CB;
    font-size: 0.875rem;
    font-weight: 500;
    text-decoration: none;
    padding: 0;
  }

  .btn-link:hover {
    color: #0F5CAB;
    text-decoration: none;
  }
  </style>